var _ellipse, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrimarySmall = function SvgPrimarySmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 188 189"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 94,
    cy: 94.318,
    fill: "#16242D",
    rx: 94,
    ry: 94.318
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85.789,
    cy: 85.789,
    r: 84.289,
    stroke: "#ABB6BD",
    strokeDasharray: "1 10",
    strokeWidth: 3,
    transform: "matrix(.70591 .7083 -.70591 .7083 94 -27.211)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.789,
    cy: 85.789,
    r: 81.789,
    stroke: "#ABB6BD",
    strokeDasharray: "1 60",
    strokeWidth: 8,
    transform: "matrix(.70591 .7083 -.70591 .7083 94 -27.211)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D26E00",
    d: "m139.579 46.187 2.256.133.133 2.264 3.237 3.248-.493-8.399-8.369-.493z"
  })));
};
export default SvgPrimarySmall;